import React from 'react';
import { ArrowRight, Lightbulb, Bot, Layout, Wrench, Target } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { SectionContainer } from '../section/SectionContainer';
import FeatureCard from './FeatureCard';
import CTAButton from '../CTAButton';
import FeatureVideo from './FeatureVideo';
import { Link } from 'react-router-dom';

const SpotlightPagesSection = () => {
  const isMobile = useIsMobile();

  const features = [
    {
      icon: <Bot size={20} className="text-[#003a70]" />,
      title: "Live AI Assistant",
      description: "Engage every visitor with an AI chatbot trained on your specific content, providing instant answers and a personalized experience 24/7."
    },
    {
      icon: <Layout size={20} className="text-[#003a70]" />,
      title: "Multimedia Landing Page",
      description: "Build a beautiful, content-rich hub with your profile, video, social links, and calls to action all on one page."
    },
    {
      icon: <Wrench size={20} className="text-[#003a70]" />,
      title: "No-Code Spotlight Builder",
      description: "Design and launch your Spotlight page in minutes with an intuitive, easy-to-use builder. No coding required."
    },
    {
      icon: <ArrowRight size={20} className="text-[#003a70]" />,
      title: "Integrated Action-Drivers",
      description: "Guide visitors with custom links and clear call-to-action buttons, perfect for booking meetings, capturing leads, or driving sales."
    }
  ];

  return (
    <SectionContainer containerWidth="wide" className="py-8 md:py-16">
      <div className="flex flex-col gap-8 md:gap-16 animate-fade-in">
        {/* Header Section */}
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#FEE6D8] text-[#003a70] text-sm font-medium mb-6">
            <Lightbulb className="h-4 w-4" />
            <span>Spotlight Pages</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#003a70] mb-6">
            Bring Anything to Life with an AI-Powered Spotlight
          </h2>
          
          <p className="text-lg text-gray-600 leading-relaxed">
            Create stunning, interactive pages for your brand, product, or profile. Combine rich media with a custom AI assistant to turn passive visitors into engaged customers.
          </p>
        </div>

        {/* Video/Demo Section */}
        <FeatureVideo
          section="spotlight-pages"
          altText="Spotlight Pages demonstration"
        />

        {/* Feature Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              delay={`${0.1 + index * 0.1}s`}
              isMobile={isMobile}
            />
          ))}
        </div>

        {/* CTA Section */}
        <div className="flex justify-center">
          <Link to="/pricing">
            <CTAButton variant="primary" className="group">
              <span className="flex items-center">
                Create Your First Spotlight Page
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </CTAButton>
          </Link>
        </div>
      </div>
    </SectionContainer>
  );
};

export default SpotlightPagesSection;
